import { useState } from 'react';

const faqs = [
  {
    q: '80s电影网的视频需要付费吗？',
    a: '完全不需要！80s电影网所有影视资源均为免费在线观看。我们致力于为广大影迷提供高清、免费、不卡的观影服务，无需注册、无需付费，点开即播。',
  },
  {
    q: '为什么叫80s电影网？有什么特别含义吗？',
    a: '80年代是电影艺术的黄金时代，诞生了无数经典作品。我们以"80s"命名，既是对那个电影黄金年代的致敬，也代表着我们对高品质影视内容的不懈追求。',
  },
  {
    q: '支持哪些设备观看？',
    a: '80s电影网全面支持电脑、平板、手机等各类设备。采用HTML5播放技术，无需安装任何插件，打开浏览器即可流畅观看。建议使用Chrome、Safari等主流浏览器获得最佳体验。',
  },
  {
    q: '视频画质怎么样？会卡顿吗？',
    a: '我们提供蓝光高清画质，最高支持4K分辨率。采用先进的CDN加速和极速播引擎技术，确保影片加载迅速、播放流畅。只要您的网络带宽充足，就能享受不缓冲的观影体验。',
  },
  {
    q: '每天什么时候更新新内容？',
    a: '我们的内容团队全天候工作，每日分多个时段更新。热门电影、电视剧会在上线后第一时间收录，动漫和综艺也会及时同步更新，确保您不错过任何精彩内容。',
  },
  {
    q: '可以下载视频离线观看吗？',
    a: '80s电影网为在线观看平台，暂不提供下载功能。但您可以随时在任意设备上打开网站观看，非常方便。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 font-bold mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于80s电影网，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-950 pr-4">
                  {faq.q}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${
                  openIndex === index ? 'rotate-45' : ''
                }`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}